module.exports = __webpack_public_path__ + "img/paylogo2.0c2a2255.png";